export enum SupportedSeverityLabels {
  critical = 'critical',
  high = 'high',
  medium = 'medium',
  low = 'low',
  informational = 'informational',
  healthy = 'healthy',
  coming_soon = 'coming_soon',
  insufficient_data = 'insufficient_data',
  pendingAssessment = 'pendingAssessment',
}
